'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Cookies from 'universal-cookie';
export type ThemeSetting = 'dark' | 'light' | 'system';
const cookies = new Cookies();
const getStoredTheme = (): ThemeSetting => {
  const cookie = cookies.get('theme');
  if (cookie === 'dark' || cookie === 'light' || cookie === 'system') {
    return cookie;
  }
  return 'dark';
};
const getEffective = (theme: ThemeSetting): 'dark' | 'light' => {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
};
const useDarkMode = () => {
  const $ = _c(7);
  const [themeSetting, setThemeSetting] = useState(getStoredTheme);
  let t0;
  if ($[0] !== themeSetting) {
    t0 = getEffective(themeSetting);
    $[0] = themeSetting;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const effectiveTheme = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = theme => {
      cookies.set("theme", theme, {
        path: "/",
        sameSite: "strict"
      });
      setThemeSetting(theme);
      document.documentElement.setAttribute("data-theme", getEffective(theme));
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setTheme = t1;
  const t2 = effectiveTheme === "dark";
  let t3;
  if ($[3] !== effectiveTheme || $[4] !== t2 || $[5] !== themeSetting) {
    t3 = {
      setTheme,
      themeSetting,
      effectiveTheme,
      isDarkMode: t2
    };
    $[3] = effectiveTheme;
    $[4] = t2;
    $[5] = themeSetting;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default useDarkMode;